<div class="m-2">
  <button translate pButton type="button" class="p-button-raised p-button-warning p-button-sm ml-1"
    (click)="showDialog()">
    <i class="fa fa-filter mr-1"></i>{{'vorPCA.filter'}}
  </button>
  <button translate pButton type="button" class="p-button-raised p-button-secondary p-button-sm ml-1"
    (click)="getAll()">
    <i class="fas fa-search mr-1"></i>{{'vorPCA.buscarDados'}}
  </button>
  <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm pull-right"
    (click)="exportExcel()">
    <i class="fa fa-download mr-1"></i>Export Excel
  </button>
</div>
<app-loading [exibir]="carregando"></app-loading>
<div class="conteiner-fluid cartoes">
  <div class="structure">
    <div class="structure divided-first">
      <div class="caixa h-100 shadow">
        <div class="row">
          <div class="col col-lg-4">
            <div class="card card-social">
              <div class="card-block border-bottom">
                <div class="row align-items-center justify-content-center">
                  <div class="col-auto">
                    <em class="far fa-clock fa-3x"></em>
                  </div>
                  <div class="col text-right">
                    <h4 translate class="text-right"
                      pTooltip="{{'rmpv.produtividade.legendaProdutividade' | translate}}" tooltipPosition="top"
                      tooltipStyleClass="tooltipSize">
                      {{'rmpv.produtividade.produtividadeCard'}}
                    </h4>
                    <h5 class="text-c-green"><strong> +
                        <ngx-odometer [number]="produtividade" [config]="configShowNumber" class="text-c-green">
                        </ngx-odometer> %</strong>
                      <span translate class="text-muted">{{'rmpv.produtividade.ideal'}}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-block">
                <div class="row align-items-center justify-content-center card-active">
                  <div class="col-6">
                    <h3 translate class="text-center  m-b-10">
                      <strong>{{produtividadeHT | number: '1.2-2'}}%</strong>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar progress-c-theme" role="progressbar"
                        [ngStyle]="{width: produtividadeHTStrg}" aria-valuenow="45" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="structure divided-second">
      <div class="caixa h-100 shadow">
        <div class="row">
          <div class="col col-lg-4">
            <div class="card card-social">
              <div class="card-block border-bottom">
                <div class="row align-items-center justify-content-center">
                  <div class="col-auto">
                    <em class="fas fa-tachometer-alt fa-3x"></em>
                  </div>
                  <div class="col text-right">
                    <h4 translate class="text-right" pTooltip="{{'rmpv.produtividade.legendaEficiencia' | translate}}"
                      tooltipPosition="top" tooltipStyleClass="tooltipSize">
                      {{'rmpv.produtividade.eficienciaCard'}}
                    </h4>
                    <h5 class="text-c-purple"><strong>+
                        <ngx-odometer [number]="eficiencia" [config]="configShowNumber" class="text-c-purple">
                        </ngx-odometer> %</strong>
                      <span translate class="text-muted">{{'rmpv.produtividade.ideal'}}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-block">
                <div class="row align-items-center justify-content-center card-active">
                  <div class="col-6">
                    <h3 translate class="text-center  m-b-10">
                      <strong>{{eficienciaHV | number: '1.2-2'}}%</strong>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar progress-c-theme" role="progressbar"
                        [ngStyle]="{width: eficienciaHVStrg}" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="structure divided-third">
      <div class="caixa h-100 shadow">
        <div class="row">
          <div class="col col-lg-4">
            <div class="card card-social">
              <div class="card-block border-bottom">
                <div class="row align-items-center justify-content-center">
                  <div class="col-auto">
                    <em class="fas fa-chart-line fa-3x"></em>
                  </div>
                  <div class="col text-right">
                    <h4 translate class="text-right" pTooltip="{{'rmpv.produtividade.legendaUtilizacao' | translate}}"
                      tooltipPosition="top" tooltipStyleClass="tooltipSize">
                      {{'rmpv.produtividade.utilizacaoCard'}}
                    </h4>
                    <h5 class="text-c-blue"> <strong>+
                        <ngx-odometer [number]="utilizacao" [config]="configShowNumber" class="text-c-blue">
                        </ngx-odometer> %</strong>
                      <span translate class="text-muted">{{'rmpv.produtividade.ideal'}}</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-block">
                <div class="row align-items-center justify-content-center card-active">
                  <div class="col-6">
                    <h3 translate class="text-center  m-b-10">
                      <strong>{{utilizacaoHV | number: '1.2-2'}}%</strong>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar progress-c-theme" role="progressbar"
                        [ngStyle]="{width: utilizacaoHVStrg}" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col">
    <strong>{{'rmpv.produtividade.legenda' | translate}}</strong>
    <div class="d-inline-flex mr-1" pTooltip="{{'rmpv.produtividade.legendaHorasTrabalhadas' | translate}}"
      tooltipPosition="top" translate>{{'rmpv.produtividade.horasTrabalhadas'}}</div>
    <div class="d-inline-flex mr-1" pTooltip=" {{'rmpv.produtividade.legendaHorasDisponiveis' | translate}} "
      tooltipPosition="top" translate>{{'rmpv.produtividade.horasDisponiveis'}}</div>
    <div class="d-inline-flex" pTooltip=" {{'rmpv.produtividade.legendaHorasVendidas' | translate}}"
      tooltipPosition="top" translate> {{'rmpv.produtividade.horasVendidas'}} </div>
  </div>
  <div class="conteudo">
    <div *ngIf="!carregando">
      <p-table [columns]="columns" [value]="data" responsiveLayout="scroll"
        styleClass="p-datatable-sm p-datatable-striped" class="style" [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'rmpv.produtividade.mostrandoRegistros' | translate}}"
        [rowsPerPageOptions]="[10,20,30,50,100]" [rowHover]="true" id="excel-table" [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.field == 'edit'" [ngStyle]="{'width': col.width}">
                <div class="text-center">
                  <i class="fa fa-info"></i>
                </div>
              </th>
              <th *ngIf="col.field != 'edit'" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field"
                [translate]="getTranslate(col.header)">
                {{col.header}}
                <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td [ngStyle]="{'text-align': col.align}">
                {{col.type ? col.type.transform(data[col.field], col.arg1) :
                  data[col.field]}}
                <button *ngIf="col.field === 'edit'" pButton type="button"
                  pTooltip="{{'rmpv.produtividade.dealerDetails' | translate}}" tooltipPosition="top"
                  class="p-button-raised p-button-info p-button-sm button" icon="fa fa-address-card"
                  (click)="goToRmpvDetalhado(rowIndex)">
                </button>
                <ng-container
                  *ngIf="col.field === 'statusEficiencia' || col.field === 'statusMaoDeObra' || col.field === 'statusProdutividade'"
                  [translate]="getTranslate(data)">
                </ng-container>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!--Dialogs-->
<ng-container>
  <p-dialog class="top-dialog" [(visible)]="display" [modal]="true" [draggable]="true" [resizable]="true">
    <ng-template pTemplate="header">
      <h5 translate class="modal-title">{{'rmpv.detalhado.filtros.definirFiltros'}}</h5>
    </ng-template>
    <ng-template pTemplate="body" styleClass="h-5rem">

      <div class="container striped-rows">
        <div class="row ptb5">
          <div class="col col-4">
            Grupo econômico
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.grupo_economico">
              <option translate disabled [value]="undefined">
                {{'rmpv.relatorioAnaliseGeral.filtros.grupoEconomicoPlaceHolder'}}
              </option>
              <option *ngFor="let item of gruposEconomicos" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div class="col col-4">
            Região
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.regiao">
              <option translate disabled [value]="undefined">{{'rmpv.relatorioAnaliseGeral.filtros.regiaoPlaceHolder'}}
              </option>
              <option *ngFor="let item of regioes" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div class="col col-4">
            Dealer
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" [(ngModel)]="filtros.dealers">
              <option translate disabled [value]="undefined">{{'rmpv.relatorioAnaliseGeral.filtros.dealerPlaceHolder'}}
              </option>
              <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            {{'rmpv.produtividade.filtros.dataInicial'}}
          </div>
          <div class="col col-8">
            <div class="input-group input-group-sm ">
              <input class="form-control" class="form-control"
                placeholder="{{'rmpv.produtividade.filtros.dataInicialPlaceHolder' | translate}}"
                [(ngModel)]="InicialData" [(ngModel)]="DataInicial" [maxDate]="max" ngbDatepicker
                #dataInicialView="ngbDatepicker" (click)="dataInicialView.toggle()">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dataInicialView.toggle()" type="button">
                  <em class="fa fa-calendar"></em>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            {{'rmpv.produtividade.filtros.dataFinal'}}
          </div>
          <div class="col col-8">
            <div class="input-group input-group-sm ">
              <input class="form-control" class="form-control"
                placeholder="{{'rmpv.produtividade.filtros.dataFinalPlaceHolder' | translate}}" [(ngModel)]="FinalData"
                [(ngModel)]="dataFinal" [maxDate]="max" ngbDatepicker #dataFinalView="ngbDatepicker"
                (click)="dataFinalView.toggle()">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dataFinalView.toggle()" type="button">
                  <em class="fa fa-calendar"></em>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">

      <button type="button" class="btn btn-info mt-1 pull-right" (click)="getAll()">OK</button>
      <button type="button" class="btn btn-outline-secondary mt-1 pull-right mr-1"
        (click)="cleanFilter() || limparDataInicial() || limparDataFinal()"><i class="fa fa-trash"
          aria-hidden="true"></i></button>
    </ng-template>
  </p-dialog>
</ng-container>
